import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Formik, FieldArray, Form as FormikForm, ErrorMessage } from 'formik';
import * as yup from 'yup';
import Select, { components } from 'react-select';
import { useSelector } from 'react-redux';
// import AssessmentApis from './assessmentApis';
import * as XLSX from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import {
  useGetAllAssessmentMutation,
  usePostEditAssessmentMutation,
  usePostAssessmentMutation,
  useGetSeriesDataMutation,
  useGetApiDataMutation,
} from 'slices/get/assessment';
import useService from 'views/default/useService';
import { useLocation } from 'react-router-dom';
import _, { values } from 'lodash';
import { useGetAllCommonAdminInitialDataMutation, usePostCommonMutation } from 'slices/get/common';
import { usePostSchoolMutation } from 'slices/get/school';

const validationSchema = yup.object().shape({
  // series_list: yup.array().min(1, 'Select at least one series'),
  // standard_list: yup.array().max(1, 'Select at least one standard'),
  // subject_list: yup.array().max(1, 'Select at least one subject'),
  // lesson_list: yup.string().required('Lesson is required'),
  part_list: yup.array().of(
    yup.object().shape({
      part: yup.string().required('Part name is required'),
    })
  ),
  active: yup.string().required('Status is required'),
  excelFile: yup.mixed().required('Excel file is required'),
});

const Control = ({ children, label, ...props }) => {
  return (
    <components.Control {...props} className="form-floating">
      {children}
      <label>{label}</label>
    </components.Control>
  );
};

const ModelAddDayPlan = ({ tableInstance }) => {
  const [getAllAssessment] = useGetAllAssessmentMutation();
  const [getSeriesData] = useGetSeriesDataMutation();
  const [getAllCommonAdminInitialData] = useGetAllCommonAdminInitialDataMutation();
  const [postAssessment] = usePostAssessmentMutation();
  const [postCommon] = usePostCommonMutation();
  const [postEditAssessment] = usePostEditAssessmentMutation();
  const { checkAccessTime, fetchAccessToken } = useService();
  const location = useLocation();
  const currentPath = location.pathname;
  let {
    isOpen,
    onCloseEmptyModal,
    whichModal,
    onCloseAddModal,

   
  } = tableInstance;
  const queryParams = new URLSearchParams(location.search);
  const subjectId = queryParams.get('subjectId');
  const standardId = queryParams.get('standardId');
  const seriesId = queryParams.get('seriesId');
  const lessonId = queryParams.get('lessonId');
  const sectionId = queryParams.get('sectionId');
  const lessonName = queryParams.get('lessonName');
  const [data, setData] = useState();
  const [seriesData, setSeriesdata] = useState([]);
  const [standardData, setStandardData] = useState([]);
  const [lessonType, setLessonType] = useState([]);
  const [lessonTitle, setLessonTitle] = useState([]);
  const [subjectData, setSubjectsdata] = useState([]);
  const [lessonData, setLessonData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [dayPlanData, setDayPlanData] = useState([]);
  const [requiredFields, setRequiredFields] = useState({
    seriesRequired: false,
    standardsRequired: false,
    subjectsRequired: false,
    lessonsRequired: false,
    schoolRequired: false,
    sectionRequired: false,
    statusRequired: false,
    lessonTypeRequird : false,
    lessonTitleRequired : false

  });

  let assessmentQuetionsData = {
    assessmentId: 10,
    questionAndOptions: [
      { question: '', options: '', answer: '' },
      { question: '', options: '', answer: '' },
    ],
  };
  const access_token = fetchAccessToken();
  const [successMessage, setSuccessMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const initialTeachers = [{ day: null, plan: null }];
  const [teachers, setTeachers] = useState(initialTeachers);
  const [postSchool] = usePostSchoolMutation();

  const [multiRequiredFields, setMultiRequiredFields] = useState(
    initialTeachers.map(() => ({ day: false, plan: false }))
  );

  useEffect(() => {
   
    // getAllCommonAdminInitialData({ ep: '/standard/data', token: access_token }).then((response) => {
    //   if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
    //     let standarOptions = response.data.data.map((each) => {
    //       if (each.active == 'on') {
    //         return { value: each.id, label: each.name };
    //       }
    //     });
    //     checkAccessTime(response, currentPath);
    //     setStandardData(standarOptions);
    //   }
    // });
    // getAllCommonAdminInitialData({ ep: '/series/data', token: access_token }).then((response) => {
    //   if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
    //     checkAccessTime(response, currentPath);
    //     let seriesOption = response.data.data.map((each) => ({ value: each.id, label: each.name }));
    //     setSeriesdata(seriesOption);
    //   }
    // });
    // getAllCommonAdminInitialData({ ep: '/subject/data', token: access_token }).then((response) => {
    //   checkAccessTime(response, currentPath);
    //   if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
    //     let subjectsOption = response.data.data.map((each) => ({
    //       value: each.id,
    //       label: each.name,
    //     }));
    //     setSubjectsdata(subjectsOption);
    //   }
    // });
    getAllCommonAdminInitialData({ ep: '/school/schools_list', token: access_token }).then(
      (response) => {
        if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
          let schoolOptions = response.data.data.map((each) => ({
            value: each.id,
            label: each.name,
          }));
          schoolOptions.unshift({value: 'all', label : 'All'})
          setSchoolData(schoolOptions);

          checkAccessTime(response, currentPath);
        }
      }
    );
    // getAllCommonAdminInitialData({ ep: '/section/section_list', token: access_token }).then(
    //   (response) => {
    //     if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
    //       let standarOptions = response.data.data.map((each) => {
    //         return { value: each.id, label: each.name };
    //       });
    //       checkAccessTime(response, currentPath);
    //       setSectionData(standarOptions);
    //     }
    //   }
    // );
  }, []); // The empty dependency array means the effect runs once after the initial render

  const [excelData, setExcelData] = useState([]);

  const initialValues = {
    series_list: [],
    standard_list: [],
    subject_list: [],
    lesson: '',
    part_list: [{ part: '', live: '', animation: '' }],
    image_list: [{ image: '' }],
    active: '',
    excelFile: null, // Add initial value for the file
  };

  const checkFields = (dayPlanData) => {
    const newRequiredFields = _.cloneDeep(requiredFields);
    // if (dayPlanData.length == 0) {
    //   newRequiredFields.seriesRequired = true;
    // }

    // if (dayPlanData.series == undefined || dayPlanData.series.length == 0) {
    //   newRequiredFields.seriesRequired = true;
    // }
    if (dayPlanData.lessonTitle == undefined || dayPlanData.lessonTitle.length == 0) {
      newRequiredFields.lessonTitleRequired = true;
    }
    // if (dayPlanData.lessonType == undefined || dayPlanData.lessonType.length == 0) {
    //   newRequiredFields.lessonTypeRequird = true;
    // }
    // if (dayPlanData.standard == undefined || dayPlanData.standard.length == 0) {
    //   newRequiredFields.standardsRequired = true;
    // }
    
    // if (dayPlanData.lessons == undefined || dayPlanData.lessons.length == 0) {
    //   newRequiredFields.lessonsRequired = true;
    // }
    if (dayPlanData.date == undefined || dayPlanData.date.length == 0) {
      newRequiredFields.dateRequired = true;
    }
    
    if (dayPlanData.school == undefined || dayPlanData.school.length == 0) {
      newRequiredFields.schoolRequired = true;
    }

    // if (dayPlanData.section == undefined || dayPlanData.section.length == 0) {
    //   newRequiredFields.sectionRequired = true;
    // }
   
    if (!dayPlanData.active || dayPlanData.active == undefined) {
      newRequiredFields.statusRequired = true;
    }
   

    setRequiredFields(newRequiredFields);
    if (
     
     
      // !newRequiredFields.subjectsRequired &&
      !newRequiredFields.schoolRequired &&
      !newRequiredFields.statusRequired 
    ) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  };

  const validateTeachers = () => {
    let isValid = true;

    const newRequiredFields = teachers.map((teacher) => ({
      dayRequired: !teacher.day, // True if no standard is selected
      // planRequired: !teacher.plan, // True if no section is selected
    }));

    setMultiRequiredFields(newRequiredFields);

    isValid = newRequiredFields.every((field) => !field.dayRequired && !field.planRequired);

    return isValid;
  };

  const addTeacher = () => {
    if (validateTeachers()) {
      const newTeacher = { day: null, plan: null };
      setTeachers([...teachers, newTeacher]);

      setMultiRequiredFields([...multiRequiredFields, { dayRequired: false, planRequired: false }]);
    }
  };
const [titleImageSets, setTitleImageSets] = useState([
    { title: '', images: [] }
  ]);

  const addTitleImageSet = () => {
    setTitleImageSets([...titleImageSets, { title: '', images: [] }]);
  };

  const removeTitleImageSet = (index) => {
    const updated = titleImageSets.filter((_, i) => i !== index);
    setTitleImageSets(updated);
  };

  const removeImage = (setIndex, imageIndex) => {
    const updated = [...titleImageSets];
    updated[setIndex].images.splice(imageIndex, 1); // Remove image at specified index
    setTitleImageSets(updated);
  };
  const [titleVideoSets, setTitleVideoSets] = useState([
    { title: '', videos: [''] } // Start with one video input field
  ]);
     const [homework, setHomework] = useState(''); // Single homework entry
     const [studentWillDo, setStudentWillDo] = useState('');
     const [conclusion, setConclusion] = useState('');
      const handleStudentWillDoChange = (e) => {
        setStudentWillDo(e.target.value); // Update the homework state
      };
   const handleConclusionChange = (e) => {
    setConclusion(e.target.value); // Update the homework state
  };

  const handleHomeworkChange = (e) => {
    setHomework(e.target.value); // Update the homework state
  };
  const addTitleVideoSet = () => {
    setTitleVideoSets([...titleVideoSets, { title: '', videos: [''] }]); // Add new title and video URL field
  };

  const removeTitleVideoSet = (index) => {
    const updated = titleVideoSets.filter((_, i) => i !== index);
    setTitleVideoSets(updated);
  };

  const handleVideoChange = (setIndex, videoIndex, value) => {
    const updated = [...titleVideoSets];
    updated[setIndex].videos[videoIndex] = value; // Update the video URL at the given index
    setTitleVideoSets(updated);
  };

  const addVideoUrlField = (setIndex) => {
    const updated = [...titleVideoSets];
    updated[setIndex].videos.push(''); // Add an empty field for a new video URL
    setTitleVideoSets(updated);
  };

  const removeVideoUrlField = (setIndex) => {
    const updated = [...titleVideoSets];
    if (updated[setIndex].videos.length > 1) {
      updated[setIndex].videos.pop(); // Remove the last video URL field
      setTitleVideoSets(updated);
    }
  };
  
  const removeTeacher = (index) => {
    const updatedTeachers = teachers.filter((_, i) => i !== index);
    const updatedRequiredFields = multiRequiredFields.filter((_, i) => i !== index);

    setTeachers(updatedTeachers);
    setMultiRequiredFields(updatedRequiredFields);
  };

  const onSubmit = (values) => {
   
  };
  // const newHandleSubmit = async () => {
  //   let checkAllRequiredFields = await checkFields(dayPlanData);
  //   if (checkAllRequiredFields.status && validateTeachers()) {
      

  //     let values = {
  //       series_id: dayPlanData.series.value,
  //       school_id: dayPlanData.school.value,
  //       standard_id: dayPlanData.standard.value,
  //       subject_id: subjectId,
  //       lesson_id: dayPlanData.lessons.value,
  //       section_id : dayPlanData.section.value,
  //       // date: dayPlanData.date,
  //       homework: dayPlanData.homework,
  //       active: dayPlanData.active,
  //       dayPlans: teachers.map((teacher) => ({
  //         day: teacher.day,
  //         plan : teacher.plan // Include date if present
          
  //       })),
  //     };

  //     postCommon({
  //       ep: '/school/day_plan_created',
  //       values,
  //       token: access_token,
  //     }).then((response) => {
  //       if(response && response?.data && response.data.status) {
  //         setSuccessMessage(response.data);
  //         setIsSuccess(true);
  //         setTimeout(() => {
  //           window.location.reload();
  //           // onCloseAddModal();
  //         }, [2000]);
  //       } else {
  //         setSuccessMessage(response.data);
  //         setIsSuccess(true);
  //       }
  //     });
  //   }
  // };
const newHandleSubmit = async () => {
  // 1️⃣ Validate your form and dynamic fields
  const allFieldsValid = (await checkFields(dayPlanData)).status && validateTeachers();
  if (!allFieldsValid) return;

  // 2️⃣ Gather everything into one “raw” object
  const payload = {
    lesson_type:   dayPlanData.lessonType?.value,
    lesson_title:  dayPlanData.lessonTitle,
    series_id:     seriesId,
    school_id:     dayPlanData.school?.value,
    standard_id:   standardId,
    subject_id:    subjectId,
    lesson_id:    lessonId,
    // section_id:    sectionId,
    // date:        dayPlanData.date,        // if you want to send date
    homework:      homework,
    studentWillDo : studentWillDo,
    conclusion : conclusion,
    active:        dayPlanData.active,
    dayPlans:      teachers.map(t => ({ day: t.day })),
    titleImageSets,                           // [{ title, images: [File,…] }, …]
    titleVideoSets                            // [{ title, videos: ['url',…] }, …]
  };
  // 3️⃣ Build FormData, skipping empty values
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value == null) return;
    if (typeof value === 'string' && value.trim() === '') return;
    if (Array.isArray(value) && value.length === 0) return;

    // For arrays of primitives/objects → JSON
    if (Array.isArray(value) && key !== 'titleImageSets') {
      formData.append(key, JSON.stringify(value));
    }
    // For everything else → toString()
    else if (key !== 'titleImageSets') {
      formData.append(key, String(value));
    }
  });

  formData.append('titleImageSetsLength', titleImageSets.length)
  titleImageSets.forEach((set, i) => {
    formData.append(`titleImageSets[${i}].title`, set.title);
    set.images.forEach((file, j) => {
      formData.append(`titleImageSets[${i}][${j}].images`, file);
    });
    formData.append(`titleImageSets[${i}].imagesLength`, set.images.length);
  });

       postSchool({
        ep: '/school/day_plan_created',
        formData,
        token: access_token,
      }).then((response) => {
        if (response && response.data && response.data.status) {
          setSuccessMessage(response.data);
          setIsSuccess(true);
          setTimeout(() => {
            // onCloseAddModal();
            window.location.reload();
          }, [2000]);
        } else {
          setSuccessMessage(response.data);
          setIsSuccess(true);
        }
      });
};

let response = {
  titleAndImagesData : [{title : "first title for images",image1:"",image2:"",image3:""},{title : "second title for images",image1:"",image2:"",image3:"",image4:"",image5:""}],
  titleAndUrlsData : [{title : "first title for images",url1:"",url2:"",url3:""},{title : "second title for urls",url1:"",url2:"",url3:"",url4:"",url5:""}]
}
  return (
    <>
      {
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
           
          }}
        >
          {({ handleSubmit, errors, touched, setFieldValue, handleBlur, values }) => (
            <FormikForm onSubmit={newHandleSubmit}>
              <Modal
                backdrop="static"
                keyboard={false}
                className="modal-right fade"
                show={isOpen}
                onHide={onCloseEmptyModal}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {whichModal.slice(0, 1).toUpperCase()}
                    {whichModal.slice(1)} Day Plan
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  {/* <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={[{ value: "I Do", label: "I Do" },{ value: "You Do", label: "You Do" },{ value: "We Do", label: "We Do" }]}
                      onChange={(selectedOptions) => {
                        requiredFields.lessonTypeRequird = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          lessonType: selectedOptions, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.lessonType}
                      placeholder="Select Lesson Type"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.lessonTypeRequird == true && (
                      <div className="d-block invalid-tooltip">Plese select Lesson Type</div>
                    )}
                  </div> */}
                  <div className="mb-3 position-relative tooltip-end-top">
                    <input
                      type="text"
                      className={`form-control ${requiredFields.lessonTitleRequired ? 'is-invalid' : ''}`} 
                      placeholder="Enter Lesson Title"
                      value={dayPlanData.lessonTitle}  // Ensure it is controlled
                      onChange={(e) => {
                        requiredFields.lessonTitleRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          lessonTitle: e.target.value, // Add/update key-value pair for 'lessonTitle'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                    />
                    {requiredFields.lessonTitleRequired && (
                      <div className="d-block invalid-tooltip">Please enter a lesson title</div>
                    )}
                  </div>
                  {/* <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={seriesData}
                      onChange={(selectedOptions) => {
                        requiredFields.seriesRequired = false;

                        setDayPlanData((prevData) => {
                          const updatedData = {
                            ...prevData,
                            series: selectedOptions, // Update 'series' in state
                          };


                          // Check if standard and subjects are defined
                          if (updatedData.standard !== undefined && subjectId !== undefined) {
                            // Assuming series is an array, map through and extract IDs or values
                            // const seriesValues = updatedData.series.map(item => item.value);

                            // Make the API call with the updated data
                            getSeriesData({
                              ep: `/lesson/get_lessons?standard_id=${updatedData.standard.value}&subject_id=${subjectId}&series_ids=${updatedData.series.value}`,
                              token: access_token,
                            }).then((response) => {
                              if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
                                let lessonOptions = response.data.data.map((each) => {
                                  if (each.active == 'on') {
                                    return { value: each.id, label: each.lesson };
                                  }
                                });
                                checkAccessTime(response, currentPath);
                                setLessonData(lessonOptions);
                              }
                            });
                          }

                          return updatedData;
                        });

                        // Optionally update required fields state
                        setRequiredFields({ ...requiredFields });
                      }}
                      value={dayPlanData.series}
                      placeholder="Select Series"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />

                    {requiredFields.seriesRequired && (
                      <div className="d-block invalid-tooltip">
                        Please select at least one series
                      </div>
                    )}
                  </div> */}
                  <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={schoolData}
                      onChange={(selectedOptions) => {
                        requiredFields.schoolRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          school: selectedOptions, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.school}
                      placeholder="Select School"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.schoolRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select school</div>
                    )}
                  </div>
                  {/* <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={standardData}
                      onChange={(selectedOptions) => {
                        setDayPlanData((prevData) => {
                          const updatedData = {
                            ...prevData,
                            standard: selectedOptions, // Update 'series' in state
                          };

                          // Check if standard and subjects are defined
                          if (updatedData.series != undefined && subjectId != undefined) {
                            getSeriesData({
                              ep: `/lesson/get_lessons?standard_id=${updatedData.standard.value}&subject_id=${subjectId}&series_ids=${updatedData.series.value}`,
                              token: access_token,
                            }).then((response) => {
                              if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
                                let lessonOptions = response.data.data.map((each) => {
                                  if (each.active == 'on') {
                                    return { value: each.id, label: each.lesson };
                                  }
                                });
                                checkAccessTime(response, currentPath);
                                setLessonData(lessonOptions);
                              }
                            });
                          }

                          return updatedData;
                        });

                        requiredFields.standardsRequired = false;

                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.standard}
                      placeholder="Select Standard"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.standardsRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select standard</div>
                    )}
                  </div> */}
                  {/* <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={sectionData}
                      onChange={(selectedOptions) => {
                        requiredFields.sectionRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          section: selectedOptions, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.section}
                      placeholder="Select Section"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.sectionRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select Section</div>
                    )}
                  </div> */}

                  {/* <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={lessonData}
                      onChange={(selectedOptions) => {
                        // console.log("selectedOptions....",selectedOptions);
                        // setFieldValue('series_list', selectedOptions);
                        // requiredFields.seriesRequired = false
                        requiredFields.lessonsRequired = false;
                        // setDayPlanData({'standard' : selectedOptions})
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          lessons: selectedOptions, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.lessons}
                      placeholder="Select Lesson"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.lessonsRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select lesson</div>
                    )}
                  </div> */}

                  <div>
                    {teachers.map((teacher, index) => (
                      <div
                        key={index}
                        style={{
                          border: '1px solid #ddd',
                          padding: '20px',
                          marginBottom: '10px',
                          borderRadius: '5px',
                        }}
                      >
                        {/* Text Input Field */}
                        <div className="mb-3 position-relative tooltip-end-top">
                          <input
                            type="text"
                            className={`form-control ${
                              multiRequiredFields[index]?.dayRequired ? 'is-invalid' : ''
                            }`}
                            placeholder="Enter Day"
                            value={teacher.day || 'Day'}
                            onChange={(e) => {
                              const updatedTeachers = [...teachers];
                              updatedTeachers[index].day = e.target.value;
                              setTeachers(updatedTeachers);

                              const updatedRequiredFields = [...multiRequiredFields];
                              updatedRequiredFields[index].dayRequired = !e.target.value;
                              setMultiRequiredFields(updatedRequiredFields);
                            }}
                          />
                          {multiRequiredFields[index]?.dayRequired && (
                            <div className="d-block invalid-tooltip">Please enter day</div>
                          )}
                        </div>

                        {/* Textarea Field */}
                        {/* <div className="mb-3 position-relative tooltip-end-top">
                          <textarea
                            className={`form-control ${
                              multiRequiredFields[index]?.planRequired ? 'is-invalid' : ''
                            }`}
                            placeholder="Enter Your Plan"
                            rows="4"
                            value={teacher.plan || ''}
                            onChange={(e) => {
                              const updatedTeachers = [...teachers];
                              updatedTeachers[index].plan = e.target.value;
                              setTeachers(updatedTeachers);

                              const updatedRequiredFields = [...multiRequiredFields];
                              updatedRequiredFields[index].planRequired = !e.target.value;
                              setMultiRequiredFields(updatedRequiredFields);
                            }}
                          />
                          {multiRequiredFields[index]?.planRequired && (
                            <div className="d-block invalid-tooltip">
                              Please enter your plan
                            </div>
                          )}
                        </div> */}

                        {/* Remove Button */}
                        {/* <Button
                          variant="danger"
                          onClick={() => removeTeacher(index)}
                          disabled={teachers.length === 1}
                        >
                          Remove Day Plan
                        </Button> */}
                      </div>
                    ))}

                    {/* Add Button */}
                   {/* <Button variant="primary" style={{marginBottom:"10px"}} onClick={addTeacher}>
                      Add Day Plan
                    </Button> */}

                  </div>
   {titleImageSets.map((set, index) => (
        <div key={index} className="border p-3 mb-3 rounded bg-light">
          {/* Title Input */}
          <textarea
            type="text"
            rows="10"
            className="form-control mb-2"
            placeholder="Enter Title"
            value={set.title}
            onChange={(e) => {
              const updated = [...titleImageSets];
              updated[index].title = e.target.value;
              setTitleImageSets(updated);
            }}
          />

          {/* Image Upload */}
          <input
            type="file"
            accept="image/*"
            multiple
            className="form-control"
            onChange={(e) => {
              const files = Array.from(e.target.files).slice(0, 10); // Limit to 10
              const updated = [...titleImageSets];
              updated[index].images = updated[index].images.concat(files); // Merge uploaded files with existing ones
              setTitleImageSets(updated);
            }}
          />

          {/* Show Selected Images Count & Names */}
          {set.images.length > 0 && (
            <div className="mt-2">
              <strong>{set.images.length} image{set.images.length > 1 ? 's' : ''} selected:</strong>
              <ul className="mb-0">
                {set.images.map((img, i) => (
                  <li key={i}>
                    {img.name} 
                    {/* Remove Image Button */}
                    <Button
                      variant="danger"
                      size="sm"
                      className="ml-2"
                      onClick={() => removeImage(index, i)}
                    >
                      Remove
                    </Button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Remove Title & Images Button */}
          <Button
            variant="danger"
            className="mt-2"
            onClick={() => removeTitleImageSet(index)}
            disabled={titleImageSets.length === 1}
          >
            Remove Title & Images
          </Button>
        </div>
      ))}

      {/* Add Button */}
      <Button variant="primary" style={{marginBottom:"10px"}} onClick={addTitleImageSet}>
        Add Title & Images
      </Button>

         <div>
      {titleVideoSets.map((set, index) => (
        <div key={index} className="border p-3 mb-3 rounded bg-light">
          {/* Title Input */}
          <textarea
            type="text"
            rows="10"
            className="form-control mb-2"
            placeholder="Enter Title"
            value={set.title}
            onChange={(e) => {
              const updated = [...titleVideoSets];
              updated[index].title = e.target.value;
              setTitleVideoSets(updated);
            }}
          />

          {/* Video URL Fields */}
          {set.videos.map((url, videoIndex) => (
            <div key={videoIndex} className="d-flex mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Video URL"
                value={url}
                onChange={(e) => handleVideoChange(index, videoIndex, e.target.value)}
              />
              <Button
                variant="danger"
                size="sm"
                className="ml-2"
                onClick={() => removeVideoUrlField(index)}
                disabled={set.videos.length === 1} // Disable minus button if only one video URL field
              >
                -
              </Button>
            </div>
          ))}

          {/* Add Video URL Field Button */}
         

          {/* Remove Title & Videos Button */}
          <Button
            variant="danger"
            className="mt-2 ml-2"
            onClick={() => removeTitleVideoSet(index)}
            disabled={titleVideoSets.length === 1}
          >
            Remove Title & Videos
          </Button>
           <Button
            variant="primary"
            size="sm"
            className="mt-2 mr-2"
            onClick={() => addVideoUrlField(index)}
          >
            +
          </Button>
        </div>
      ))}

      {/* Add Title & Video Set Button */}
      <Button variant="primary" style={{marginBottom:"10px"}} onClick={addTitleVideoSet}>
        Add Title & Videos
      </Button>
    </div>
    <div className="mb-3">
  <label className="form-label">Student Will Do</label>

  <textarea
    className="form-control"
    rows="10"
    placeholder="Enter Student Will Do"
    value={studentWillDo}
    onChange={handleStudentWillDoChange}
  />
</div>
<div className="mb-3">
  <label className="form-label">Conclusion</label>

  <textarea
    className="form-control"
    rows="10"
    placeholder="Enter Conclusion"
    value={conclusion}
    onChange={handleConclusionChange}
  />
</div>
 <div className="mb-3">
  <label className="form-label">Home Practice</label>

  <textarea
    className="form-control"
    rows="10"
    placeholder="Enter Home Practice"
    value={homework}
    onChange={handleHomeworkChange}
  />
</div>

 {/* <textarea
        className="form-control"
        rows="6"
        placeholder="Enter Home Practice"
        value={homework}
        onChange={handleHomeworkChange}
      /> */}


                  <div className="mb-3 filled tooltip-end-top">
                    <Form.Label>Status</Form.Label>
                    <Form.Check
                      type="radio"
                      label="On"
                      value="on"
                      id="statusRadio1"
                      name="active"
                      checked={dayPlanData.active === 'on'}
                      onChange={(event) => {
                        // setFieldValue('active', event.target.value);
                        requiredFields.statusRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          active: event.target.value, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="Off"
                      value="off"
                      id="statusRadio2"
                      name="active"
                      checked={dayPlanData.active === 'off'}
                      onChange={(event) => {
                        // setFieldValue('active', event.target.value);
                        requiredFields.statusRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          active: event.target.value, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                    />
                    {requiredFields.statusRequired == true && (
                      <div className="d-block invalid-tooltip">Please select status</div>
                    )}
                  </div>
                </Modal.Body>

                {isSuccess && (
                  <div
                    className={`card mb-3 ${
                      successMessage.status ? 'bg-success' : 'bg-danger'
                    } text-white`} // Dynamically set the background color based on success or failure
                    style={{ marginTop: '5px' }}
                  >
                    <div className="card-body">
                      <p className="card-text">{successMessage.message}</p>
                    </div>
                  </div>
                )}
                <Modal.Footer>
                  <Button variant="outline-primary" onClick={onCloseEmptyModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={newHandleSubmit}>
                    Add
                  </Button>
                </Modal.Footer>
              </Modal>
            </FormikForm>
          )}
        </Formik>
      }
    </>
  );
};

export default ModelAddDayPlan;
